const Syntax = {
	'A': '[A-z]',
	'0': '\\d',
	'-': '-',
	' ': '\\s',
	'/': '/',
}

/** @type {Partial<Record<typeof keyof Syntax, boolean>>} */
const Autocomplete = {
	'-': true,
	' ': true,
	'/': true,
}

/**
 *
 * @param {string} token
 * @return {string | undefined}
 */
const getRegExpAtom = (token) => Syntax[token];

/**
 *
 * @param {string} token
 * @returns {boolean}
 */
const getAutocompleteToken = (token) => !!Autocomplete[token];

/**
 *
 *
 */
function isMaskValid(mask) {
	return Array.from(mask).every((token) => !!getRegExpAtom(token));
}

/**
 *
 * @param {string} mask
 * @param {string} input
 * @returns {string}
 */
export function trimInputByMask(mask, input) {
	const invalidSymbol = Array
		.from(input)
		.findIndex((symbol, index) => {
			const atom = getRegExpAtom(mask[index]);

			if (!atom) return true;
			if (!RegExp(atom).test(symbol)) return true;
		});

	if (invalidSymbol >= 0)
		return Array.from(input).slice(0, invalidSymbol).join('');

	return input;
}

/**
 *
 * @param {string} mask
 * @param {string} input
 * @returns {string}
 */
export function autocompleteInputWithMask(mask, input) {
	return Array
		.from(mask)
		.reduce((autocompleted, token, index) => {
			const isAutocomplete = getAutocompleteToken(token);
			const regExpAtom = getRegExpAtom(token);

			if (!isAutocomplete)
				return autocompleted;

			if (RegExp(regExpAtom).test(input[index]))
				return autocompleted;

			autocompleted.splice(index, 0, token);

			return autocompleted;
		}, Array.from(input))
		.join('');
}

/**
 *
 * @param {string} mask
 * @param {string} input
 * @returns {string}
 */
export function applyMask(mask, input) {
	const empty = mask === '';
	const invalid = !isMaskValid(mask);

	if (empty || invalid) return input;

	const autocompletedInput = autocompleteInputWithMask(mask, input);

	return trimInputByMask(mask, autocompletedInput);
}
